<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.stockcontrols') }} {{ '> ' + warehouse_name }}
          </div>
        </div>
        <template v-if="device.isMobile">
          <div class="col-4 right">
            <div class="action">
              <div
                id="dropdownOptions"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    v-if="hasRoleEdit"
                    class="dropdown-item"
                    @click="openAdjustmentModal(null, null)">
                    <i class="fas fa-redo-alt"/>
                    <span class="name">{{ $t('apps.inventory.message.adjustmentstock') }}</span>
                  </a>
                  <a
                    v-if="hasRoleEdit"
                    class="dropdown-item"
                    @click="openTransferModal()">
                    <i class="fas fa-exchange-alt"/>
                    <span class="name">{{ $t('button.transfer') }}</span>
                  </a>
                  <a
                    v-if="hasRoleEdit"
                    class="dropdown-item"
                    @click="openIssueModal(null, 'manual issue')">
                    <i class="fas fa-sign-out-alt"/>
                    <span class="name">{{ $t('apps.inventory.message.manualissue') }}</span>
                  </a>
                  <a
                    v-if="hasRoleEdit"
                    class="dropdown-item"
                    @click="openIssueModal(null, 'manual return')">
                    <i
                      class="fas fa-sign-in-alt"
                      style="transform: rotate(180deg);"/>
                    <span class="name">{{ $t('apps.inventory.message.manualreturn') }}</span>
                  </a>
                  <a
                    :disabled="isDisabledPrint"
                    class="dropdown-item"
                    @click="openPrintModal()">
                    <i
                      v-if="isDisabledPrint"
                      class="fas fa-spinner spin"/>
                    <i
                      v-else
                      class="fas fa-print"/>
                    <span class="name">{{ $t('button.print') }}</span>
                  </a>
                  <a
                    :disabled="isDisabledExport"
                    class="dropdown-item"
                    @click="exportAs('xlsx')">
                    <i
                      v-if="isDisabledExport"
                      class="fas fa-spinner spin"/>
                    <i
                      v-else
                      class="fas fa-download"/>
                    <span class="name">{{ $t('button.download') }} Excel</span>
                  </a>
                  <a
                    :disabled="isDisabledExport"
                    class="dropdown-item"
                    @click="exportAs('csv')">
                    <i
                      v-if="isDisabledExport"
                      class="fas fa-spinner spin"/>
                    <i
                      v-else
                      class="fas fa-download"/>
                    <span class="name">{{ $t('button.download') }} CSV</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-8 right">
            <div class="action">
              <div
                v-if="hasRoleEdit"
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openIssueModal(null, 'manual return')">
                  <i
                    class="fas fa-sign-in-alt"
                    style="transform: rotate(180deg);"/>
                  <span class="name">{{ $t('apps.inventory.message.manualreturn') }}</span>
                </button>
              </div>
              <div
                v-if="hasRoleEdit"
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openIssueModal(null, 'manual issue')">
                  <i class="fas fa-sign-out-alt"/>
                  <span class="name">{{ $t('apps.inventory.message.manualissue') }}</span>
                </button>
              </div>
              <div
                v-if="hasRoleEdit"
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openTransferModal()">
                  <i class="fas fa-exchange-alt"/>
                  <span class="name">{{ $t('button.transfer') }}</span>
                </button>
              </div>
              <div
                v-if="hasRoleEdit"
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openAdjustmentModal(null, null)">
                  <i class="fas fa-redo-alt"/>
                  <span class="name">{{ $t('apps.inventory.message.adjustmentstock') }}</span>
                </button>
              </div>
              <div class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  :disabled="isDisabledExport"
                  class="btn no-bg dropdown-toggle text-secondary"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i
                    v-if="isDisabledExport"
                    class="fas fa-spinner spin"/>
                  <i
                    v-else
                    class="fas fa-download"/>
                  <span class="name">{{ $t('button.download') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    :class="['dropdown-item', { 'disabled': isDisabledExport }]"
                    @click="exportAs('xlsx')
                    ">
                    <span class="text-secondary">Excel</span>
                  </a>
                  <a
                    :class="['dropdown-item', { 'disabled': isDisabledExport }]"
                    @click="exportAs('csv')"
                  >
                    <span class="text-secondary">CSV</span>
                  </a>
                </div>
              </div>
              <div class="dropdown nodro item">
                <button
                  :disabled="isDisabledPrint"
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openPrintModal()">
                  <i
                    v-if="isDisabledPrint"
                    class="fas fa-spinner spin"/>
                  <i
                    v-else
                    class="fas fa-print"/>
                  <span class="name">{{ $t('button.print') }}</span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready"
        class="row mb-3">
        <div class="col-lg-4 ml-auto">
          <label class="d-flex d-flex align-items-center">
            <span class="mr-2">
              {{ $t('message.search') }}:
            </span>
            <base-input
              v-model="query.q"
              :placeholder="$t('placeholder.searchstock')"
              type="text"
              clear
              @onEnter="handleSearchEnter"
              @onClear="handleSearchClear"
            />
          </label>
        </div>
      </div>

      <base-table
        v-if="ready"
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th>
                <base-sort-label
                  v-model="sort.product"
                  @onChange="handleOnChangeSortProduct"
                >
                  {{ $t('message.item') }}
                </base-sort-label>
              </th>
              <th class="text-center no-sort">{{ $t('apps.inventory.message.warningstock') }}</th>
              <th
                v-if="hasAnyMaxStock"
                class="text-center no-sort">{{ $t('apps.inventory.message.maxstock') }}</th>
              <th
                class="no-sort"
                style="max-width: 200px;">{{ $t('apps.inventory.message.binlocation') }}</th>
              <th class="text-center">
                <base-sort-label
                  v-model="sort.instock"
                  @onChange="handleOnChangeSortInstock"
                >
                  {{ $t('apps.inventory.message.balance') }}
                </base-sort-label>
              </th>
              <th
                v-if="hasAnyUnit"
                class="text-center no-sort">{{ $t('message.unit') }}</th>
              <th
                v-if="hasRoleEdit"
                class="no-sort"/>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="stocks.length === 0"
                colspan="6"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in stocks"
              :key="index">
              <td>
                <div
                  class="d-flex align-items-center"
                  style="gap: 8px;">
                  <img
                    v-if="hasAnyImage"
                    :src="productImage(item.sku)"
                    width="30"
                    height="30">
                  <router-link-custom
                    :to="{name: 'ProductEdit', query: {
                      pid: item.product.product_id,
                      pname: item.product.product_name
                    }}"
                    :text="getProductFullName(item.product.product_name, item.sku.attributes)"
                    :to_appid="2"
                    :current_appid="3"/>
                </div>
              </td>
              <td class="text-center">
                {{ getNumber(item.stock.control.minstock) }}
              </td>
              <td
                v-if="hasAnyMaxStock"
                class="text-center">
                {{ getNumber(item.stock.control.maxstock) }}
              </td>
              <td style="max-width: 200px;">
                <div
                  class="d-flex"
                  style="gap: 5px"
                >
                  <span
                    v-for="(v, i) in getBinLocationNamesByStock(item)"
                    :key="i"
                    class="badge badge-secondary">
                    {{ v }}
                  </span>
                </div>
              </td>
              <td
                :data-order="item.stock.instock"
                class="text-center">
                {{ getNumber(item.stock.instock) }}
              </td>
              <td
                v-if="hasAnyUnit"
                class="text-center">
                {{ item.product.unit }}
              </td>
              <td
                v-if="hasRoleEdit"
                class="text-center">
                <div class="dropdown">
                  <button
                    id="dropdownMenuButton"
                    class="btn no-bg dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <span class="name">
                      {{ $t('message.option') }}
                    </span>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownMenuButton">
                    <a
                      class="dropdown-item"
                      @click="openStockWarningModal(item)">
                      <i class="fas fa-sort-numeric-down"/>
                      {{ $t('apps.inventory.message.warningstock') }}
                    </a>
                    <a
                      class="dropdown-item"
                      @click="openStockBinModal(item)">
                      <i class="fas fa-boxes"/>
                      {{ $t('apps.inventory.message.binlocation') }}
                    </a>
                    <div class="dropdown-divider"/>
                    <a
                      class="dropdown-item"
                      @click="openAdjustmentModal(item.sku.sku_id)">
                      <i class="fas fa-redo-alt"/>
                      {{ $t('apps.inventory.message.adjustmentstock') }}
                    </a>
                    <a
                      class="dropdown-item"
                      @click="openTransferModal(item.sku.sku_id)">
                      <i class="fas fa-exchange-alt"/>
                      {{ $t('button.transfer') }}
                    </a>
                    <a
                      class="dropdown-item"
                      @click="openAdjustmentModal(item.sku.sku_id, 'manual issue')">
                      <i class="fas fa-sign-out-alt"/>
                      {{ $t('apps.inventory.message.manualissue') }}
                    </a>
                    <a
                      class="dropdown-item"
                      @click="openAdjustmentModal(item.sku.sku_id, 'manual return')">
                      <i
                        class="fas fa-sign-in-alt"
                        style="transform: rotate(180deg);"/>
                      {{ $t('apps.inventory.message.manualreturn') }}
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>
    </div>

    <div
      id="adjustmentModal"
      class="modal bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('apps.inventory.message.adjustmentstock') }}</h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeAdjustmentModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <modal-adjustment
              v-if="isShowAdjustmentModal"
              :data.sync="adjustmentData"
              :reason="reason"
              :sku_id="adjustmentSkuId"/>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeAdjustmentModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="adjustmentData.items.length == 0"
              type="button"
              class="btn btn-web"
              @click="updateStock()"
            >{{ $t('button.apply') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="issueModal"
      class="modal bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <span v-if="reason == 'manual issue'">{{ $t('apps.inventory.message.manualissue') }}</span>
              <span v-if="reason == 'manual return'">{{ $t('apps.inventory.message.return') }}</span>
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeIssueModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <modal-issue-return
              v-if="isShowIssueModal"
              :data.sync="adjustmentData"
              :sku_id="adjustmentSkuId"
              :reason="reason"
            />
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeIssueModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="adjustmentData.items.length == 0"
              type="button"
              class="btn btn-web"
              @click="updateStock()"
            >{{ $t('button.apply') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="stockwarningModal"
      class="modal bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('apps.inventory.message.warningstock') }}</h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeStockWarningModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section v-if="stockwarningItemClone">
              <div class="form-row">
                <div class="col-md-6">
                  <label>{{ $t('apps.inventory.message.minstock') }}</label>
                  <input
                    v-model="stockwarningItemClone.stock.control.minstock"
                    type="number"
                    class="form-control text-select-all">
                </div>
                <div class="col-md-6">
                  <label>{{ $t('apps.inventory.message.maxstock') }}</label>
                  <input
                    v-model="stockwarningItemClone.stock.control.maxstock"
                    type="number"
                    class="form-control text-select-all">
                </div>
              </div>
            </section>
            <section class="mb-0">
              <div class="col-md-12 no-padding mb-0">
                {{ $t('apps.inventory.message.notificationwhenlowstocklevel') }}
                <a
                  href="https://www.treesoft.io/th/manual/inventory#stockcontrol"
                  target="_blank">
                  {{ $t('button.learnmore') }}
                  <i class="fas fa-external-link-alt"/>
                </a>
              </div>
            </section>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeStockWarningModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              @click="updateStockWarning()">{{ $t('button.apply') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="printModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div
            class="modal-body p-0"
            style="background: #C9CCCE;height: 660px;overflow: auto;">
            <printpreview
              v-if="ready"
              :stocks="allStocks"
              :warehouse="{'name': warehouse_name}"
              :time="openedPrintPreviewTime"
              class="print-template"/>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-web"
              @click="onclickPrint()">{{ $t('button.print') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="closePrintModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="transferModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('apps.inventory.message.transfer') }}</h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeTransferModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <modal-transfer
              v-if="isShowTransferModal"
              :data.sync="transferData"
              :sku_id="transferSkuId"/>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeTransferModal()"
            >{{ $t('button.cancel') }}</button>
            <button
              :disabled="this.transferData.items.length == 0"
              type="button"
              class="btn btn-web"
              @click="updateStockTransfer()"
            >{{ $t('button.apply') }}</button>
          </div>
          <div
            v-else
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i
                v-if="this.transferData.items.length > 0"
                class="fas fa-spinner spin"/>
              <span v-else>{{ $t('button.apply') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="stockbinModal"
      class="modal bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('apps.inventory.message.binlocation') }}</h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeStockBinModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="formStockBin.stock_id"
            class="modal-body">
            <section class="mb-0">
              <div class="form-row">
                <div class="col-md-12">
                  <label>
                    {{ $t('apps.inventory.message.binlocationlabel') }}
                    <i
                      v-b-popover.hover.right="$t('apps.inventory.message.hintforprimarybinlocation')"
                      :title="$t('message.advise')"
                      class="fas fa-info-circle"
                      style="color: #ccc"
                    />
                  </label>
                  <vue-bootstrap-autocomplete
                    v-model="formStockBin.input"
                    :data="warehouseBinCodes"
                    :minMatchingChars="1"
                    :showOnFocus="true"
                  />
                </div>
              </div>
            </section>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeStockBinModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              @click="updateStockBin()">{{ $t('button.apply') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import printpreview from '@/components/apps/inventory/stockcontrol/include/PrintPreview.vue'
import modalTransfer from '@/components/apps/inventory/stockcontrol/include/ModalTransfer.vue'
import modalAdjustment from '@/components/apps/inventory/stockcontrol/include/ModalAdjustment.vue'
import modalIssueReturn from '@/components/apps/inventory/stockcontrol/include/ModalIssueReturn.vue'
import useBarcodeScanner from '../../../../use/barcodeScanner'
import _ from 'lodash'
import XLSX from 'xlsx'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'StockControl',

  mixins: [userPermissionMixin],

  setup () {
    const {
      barcode,
    } = useBarcodeScanner({ delay: 100 })

    return {
      barcode,
    }
  },

  components: {
    printpreview,
    modalTransfer,
    modalAdjustment,
    modalIssueReturn,
  },

  data () {
    return {
      ready: false,

      warehouse_name: null,
      warehouse_name_short: null,
      currentWhId: null,

      stockwarningItemClone: null,

      openedPrintPreviewTime: null,

      isShowTransferModal: false,
      transferData: { items: [] },
      transferSkuId: null,

      isShowAdjustmentModal: false,
      adjustmentData: { items: [] },
      adjustmentSkuId: null,

      isShowIssueModal: false,
      reason: null,

      isDisabledExport: false,
      isDisabledPrint: false,

      allStocks: [],

      focus: 'main', // main, adjust

      sort: {
        // asc, desc, null
        product: null,
        instock: null,
      },

      query: {
        wh_id: this.$route.query.wh_id,
        page: this.$route.query.page,
        q: this.$route.query.q,
        sort: this.$route.query.sort,
      },

      formStockBin: {
        stock_id: null,
        input: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      stocks: 'getStocks',
      refreshStocks: 'getRefreshStocks',
      sidebar: 'getSidebar',
      auth: 'getAuth',
      defaultImages: 'getDefaultImages',
    }),
    warehouseBins () {
      return this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.$route.query.wh_id) {
          acc = cur.bin_locations
        }
        return acc
      }, [])
    },
    warehouseBinCodes() {
      return this.warehouseBins.map((v) => v.code)
    },
    hasAnyImage() {
      return this.stocks.some((stock) => stock.sku.images && stock.sku.images.thumbnail)
    },
    hasAnyMaxStock() {
      return this.stocks.some((item) => item.stock.control.maxstock != null)
    },
    hasAnyUnit() {
      return this.stocks.some((stock) => stock.product.unit)
    },
  },

  watch: {
    ready (newVal) {
      if (newVal === true) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses (newVal, oldVal) {
      let primaryWhId = this.getWhIdPrimary(this.warehouses)
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 1,
        submenuAtIdx: this.getSubmenuIdx(primaryWhId),
      })
      this.setSubTitle(primaryWhId)
      this.loadStocks(primaryWhId)
      this.currentWhId = primaryWhId
    },
    $route (to, from) {
      if (Object.keys(to.query).length === 1 && to.query.wh_id) {
        this.query.page = undefined
        this.query.q = undefined
        this.query.sort = null
        this.sort.product = null
        this.sort.instock = null
      }

      if (to.query.wh_id !== from.query.wh_id) {
        const wh_id = to.query.wh_id
        this.query.wh_id = wh_id
        sidebarModule.init(this.getObject(require('../sidebar.json')))
        sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
        sidebarModule.active({
          sidebarAtIdx: 1,
          submenuAtIdx: this.getSubmenuIdx(wh_id),
        })
        this.setSubTitle(wh_id)
        this.loadStocks(wh_id)
        this.currentWhId = wh_id
      }
    },
    refreshStocks: async function (newVal, oldVal) {
      // reload data
      await this.loadStocks(this.currentWhId)

      // close popup modal
      this.closeAdjustmentModal()
      // close popup modal
      this.closeStockWarningModal()
      // close popup modal
      this.closeStockBinModal()
    },
  },
  async created () {
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
  },
  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 2,
      },
    })
    // set sidebar stockcontrols ui
    if (this.warehouses.length > 0) {
      let primaryWhId = this.getWhIdPrimary(this.warehouses)
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 1,
        submenuAtIdx: this.getSubmenuIdx(primaryWhId),
      })
      this.setSubTitle(primaryWhId)
      this.loadStocks(primaryWhId)
      this.currentWhId = primaryWhId
    }
  },
  mounted () {
    // set popup modal
    this.setModal('#adjustmentModal')
    this.setModal('#issueModal')
    this.setModal('#stockwarningModal')
    this.setModal('#stockbinModal')
    this.setModal('#printModal')
    this.setModal('#transferModal')

    window.addEventListener('barcode', this.onBarcode)
  },
  destroyed () {
    this.leavePage(this.$Progress, ['clearStock'])
    window.removeEventListener('barcode', this.onBarcode)
  },

  methods: {
    async getAllStocks () {
      const response = await this.$store.dispatch('getAllStocks', {
        wh: this.query.wh_id,
        q: this.query.q,
        sort: this.query.sort,
      })
      this.showFinish(this.$Progress)
      return response
    },
    setSubTitle (wh_id) {
      for (let i in this.warehouses) {
        let wh = this.warehouses[i]
        if (wh_id == wh.warehouse_id) {
          this.warehouse_name = wh.warehouse_name
          this.warehouse_name_short = wh.short_name
        }
      }
    },
    async loadStocks (wh_id) {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getStocks', {
        wh: wh_id,
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        q: this.query.q,
        sort: this.query.sort,
      })
      this.ready = true
      this.showFinish(this.$Progress)
    },
    getWhIdPrimary (warehouses) {
      var wh_id = null
      if (this.$route.query.wh_id) {
        wh_id = this.$route.query.wh_id
      } else {
        let foundPrimary = false
        for (let i in this.warehouses) {
          let wh = this.warehouses[i]
          if (wh.primary && !foundPrimary) {
            foundPrimary = true
            wh_id = wh.warehouse_id
          }
        }
      }
      return wh_id
    },
    getSubmenuIdx (wh_id) {
      let submenus = this.sidebar[1].submenus
      for (let i in submenus) {
        if (wh_id == submenus[i].router.query.wh_id) {
          return i
        }
      }
    },
    getSubmenuWarehouses (warehouses) {
      var submenus = []
      for (let i in warehouses) {
        let wh = warehouses[i]
        var submenu = {
          'name': wh.warehouse_name,
          'router': {
            'name': 'StockControl',
            'query': {
              'wh_id': wh.warehouse_id,
            },
          },
          'activeClass': '',
        }
        submenus.push(submenu)
      }
      return submenus
    },
    openAdjustmentModal (skuId, reason) {
      this.isShowAdjustmentModal = true
      this.adjustmentSkuId = skuId || null
      this.reason = reason
      this.focus = 'adjust'
      $('#adjustmentModal').modal('show')
    },
    closeAdjustmentModal () {
      this.isShowAdjustmentModal = false
      this.focus = 'main'
      $('#adjustmentModal').modal('hide')
    },
    openIssueModal (skuId, reason) {
      this.isShowIssueModal = true
      this.adjustmentSkuId = skuId || null
      this.reason = reason
      this.focus = 'adjust'
      $('#issueModal').modal('show')
    },
    closeIssueModal () {
      this.isShowIssueModal = false
      this.focus = 'main'
      $('#issueModal').modal('hide')
    },
    openStockWarningModal (item) {
      this.stockwarningItemClone = _.cloneDeep(item)
      $('#stockwarningModal').modal('show')
    },
    closeStockWarningModal () {
      $('#stockwarningModal').modal('hide')
    },
    getStockBySkuId (sku_id) {
      for (let i in this.stocks) {
        if (this.stocks[i].sku.sku_id == sku_id) {
          return this.stocks[i]
        }
      }
      return null
    },
    async updateStock () {
      let dataSet = {
        'orders': this.adjustmentData.items,
      }

      let res = await this.$store.dispatch('updateStock', dataSet)

      if (res.success) {
        this.notify(this.$vs, {
          text: this.$t('apps.inventory.message.stockadjustmenthasbeenupdated'),
          color: 'success',
          icon: 'cloud',
        })
      }

      this.closeIssueModal()
    },
    async updateStockWarning () {
      var min = this.stockwarningItemClone.stock.control.minstock
      var max = this.stockwarningItemClone.stock.control.maxstock

      min = !min ? null : parseFloat(min)
      max = !max ? null : parseFloat(max)

      let data = {
        'stock_id': this.stockwarningItemClone.stock.stock_id,
        'min': min,
        'max': max,
      }

      let res = await this.$store.dispatch('updateStockWarning', data)

      if (res.success) {
        let nameProduct = this.getProductFullName(this.stockwarningItemClone.product.product_name, this.stockwarningItemClone.sku.attributes)
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.updated'),
          color: 'success',
          icon: 'cloud',
        })
      }
    },
    openStockBinModal (data) {
      this.formStockBin.stock_id = data.stock.stock_id

      if (data.stock.primary_bin_location_id) {
        const bin = this.warehouseBins.find((binItem) => binItem._id == data.stock.primary_bin_location_id)
        if (bin) {
          this.formStockBin.input = bin.code
        }
      }

      $('#stockbinModal').modal('show')
    },
    closeStockBinModal () {
      $('#stockbinModal').modal('hide')
    },
    async updateStockBin () {
      const binName = this.formStockBin.input
      let binId = null

      // get bin that is already exist
      const existBin = this.warehouseBins.find((bin) => bin.code === binName)

      if (existBin) {
        binId = existBin._id
      } else if (binName != null && binName.trim().length) {
        const resNewBin = await this.$store.dispatch('insertWarehouseBins', {
          id: this.$route.query.wh_id,
          data: {
            bins: [
              {
                code: binName,
              },
            ],
          },
        })
        binId = resNewBin.data[0]._id
      }

      const res = await this.$store.dispatch('updateStockBin', {
        stock_id: this.formStockBin.stock_id,
        primary_bin_location_id: binId,
      })

      if (res.success) {
        await this.$store.dispatch('getWarehouses')

        this.formStockBin.stock_id = null
        this.formStockBin.input = null

        this.notify(this.$vs, {
          text: this.$t('message.updated'),
          color: 'success',
          icon: 'cloud',
        })
      }
    },
    async openPrintModal () {
      this.isDisabledPrint = true
      const response = await this.getAllStocks()
      this.isDisabledPrint = false
      this.allStocks = response.data

      $('#printModal').modal('show')
      // set modal height
      $('#printModal .modal-body').css({
        height: window.innerHeight - 125 + 'px',
      })
      $('#printModal .modal-body').animate({ scrollTop: 0 }, 0)
      this.openedPrintPreviewTime = this.moment().format('YYYY-MM-DD H:m:s')
    },
    closePrintModal () {
      $('#printModal').modal('hide')
    },
    onclickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    openTransferModal (skuId) {
      $('#transferModal').modal('show')
      this.isShowTransferModal = true
      this.transferSkuId = skuId || null
    },
    closeTransferModal () {
      $('#transferModal').modal('hide')
      this.isShowTransferModal = false
    },
    async updateStockTransfer () {
      var dataSet = {
        'orders': this.transferData.items,
      }

      let res = await this.$store.dispatch('updateStockTransfer', dataSet)

      if (res.success) {
        this.notify(this.$vs, {
          text: this.$t('apps.inventory.message.stocktransferhasbeenupdated'),
          color: 'success',
          icon: 'cloud',
        })
      }

      this.closeTransferModal()
    },
    async exportAs (fileType) {
      if (!['xlsx', 'csv'].includes(fileType)) {
        console.error('Invalid file type')
        return
      }

      this.isDisabledExport = true
      const response = await this.getAllStocks()
      this.isDisabledExport = false

      /* convert state to workbook */
      const headColumns = ['รายการ', 'สต๊อกขั้นต่ำ', 'ที่จัดเก็บ', 'คงเหลือ']
      const bodyRows = response.data.map((item) => {
        const { product, sku, stock } = item
        const productName = this.getProductFullName(product.product_name, sku.attributes)
        const minStock = stock.control.minstock || ''
        const binLocation = this.getBinLocationNamesByStock(item).join(', ')
        const instock = stock.instock || ''
        const columns = [productName, minStock, binLocation, instock]
        return columns
      })
      const data = [headColumns, ...bodyRows]
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet')

      /* generate file and send to client */
      const fileName = `${this.moment().format('YYYYMMDD')}-${this.warehouse_name_short}.${fileType}`

      XLSX.writeFile(wb, fileName)
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.loadStocks(this.query.wh_id)
    },
    handleSearchEnter () {
      this.query.page = undefined
      this.loadStocks(this.query.wh_id)
    },
    handleSearchClear () {
      this.query.q = undefined
      this.query.page = undefined
      this.query.sort = undefined
      this.sort.product = null
      this.sort.instock = null
      this.loadStocks(this.query.wh_id)
    },
    handleOnChangeSortProduct (sort = null) {
      if (sort) {
        this.query.sort = `product:${sort}`
        this.sort.instock = null
      } else {
        this.query.sort = null
      }
      this.query.page = undefined
      this.loadStocks(this.query.wh_id)
    },
    handleOnChangeSortInstock (sort = null) {
      if (sort) {
        this.query.sort = `instock:${sort}`
        this.sort.product = null
      } else {
        this.query.sort = null
      }
      this.query.page = undefined
      this.loadStocks(this.query.wh_id)
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
    onBarcode (event) {
      if (this.focus === 'main') {
        this.query.q = event.detail.code
        this.query.page = undefined
        this.loadStocks(this.query.wh_id)
      }
    },
    getBinLocationNamesByStock(stock) {
      const binIds = []

      const stockLocations = [
        ...stock.stock_locations,
      ]

      const isFoundPrimaryBinInLocation = stock.stock_locations
        .find((bin) => bin.bin_location_id === stock.stock.primary_bin_location_id)
      if (!isFoundPrimaryBinInLocation) {
        stockLocations.unshift({
          bin_location_id: stock.stock.primary_bin_location_id,
          instock: 0,
        })
      }

      stockLocations.forEach(item => {
        if (item.bin_location_id != null && !binIds.includes(item.bin_location_id)) {
          binIds.push(item.bin_location_id)
        }
      })

      const results = binIds
        .map((id) => this.getBinLocationNamesById(id))
        .filter((v) => v)
        .map((binName) => {
          const location = stockLocations.find((item) => item.code === binName)
          let instock = 0
          if (location) {
            instock = location.instock
          }
          return {
            binName,
            instock,
          }
        })

        // add not specific bin
      if (results.length) {
        const totalAll = stock.stock.instock
        const totalInBins = results.reduce((acc, cur) => cur.instock + acc, 0)
        const diff = totalAll - totalInBins
        if (totalAll != 0 && totalAll !== totalInBins) {
          results.push({
            binName: this.$t('apps.inventory.message.notspecifiedshort'),
            instock: diff,
          })
        }
      }

      return results
        .map((result) => {
          let str = result.binName
          if (result.instock != 0) {
            if (results.length > 1) {
              str += ` (${result.instock})`
            }
          }
          return str
        })
    },
    getBinLocationNamesById(binId) {
      const bins = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.query.wh_id) {
          acc = cur.bin_locations
        }
        return acc
      }, [])
      const bin = bins.find((bin) => bin._id === binId)
      return bin
        ? bin.code
        : null
    },
    productImage (sku) {
      const skuImage = sku.images && sku.images.thumbnail
      return skuImage || this.defaultImages.product
    },
  },
}
</script>

<style scoped>
#content .header-inner .right .action button {
  float: right;
  border-left: solid 1px #D8E2E7;
  padding-top: 0;
  padding-bottom: 0;
}
#content .header-inner .right .action button:first-of-type {
  padding-right: 0;
}
#content .header-inner .right .action button:last-of-type {
  border-left: none;
}
.dropdown > button {
  padding: 0;
}
.dropdown a.dropdown-item i {
  width: 16px;
}

#content >>> table tr td {
  padding: 8px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/stockcontrol/List.vue